let listeners = [];
let toastId = 0;

export const subscribeToToasts = (listener) => {
  listeners.push(listener);

  return () => {
    listeners = listeners.filter((item) => item !== listener);
  };
};

const notify = (payload) => {
  listeners.forEach((listener) => listener(payload));
};

export const dismissToast = (id) => {
  notify({ id, dismiss: true });
};

export const showToast = ({ message, type = "error", duration = 4000 }) => {
  const id = ++toastId;

  notify({ id, message, type });

  if (duration > 0) {
    window.setTimeout(() => dismissToast(id), duration);
  }

  return id;
};

export const getApiErrorMessage = (error, fallback) => {
  if (!navigator.onLine || error?.status === "FETCH_ERROR") {
    return "No internet connection. Please check your network and try again.";
  }

  return error?.data?.message || error?.message || fallback;
};
